var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollFurther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 30,
    viewBox: "0 0 17 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19 0C3.66 0 0 3.66 0 8.19V21.81C0 26.34 3.66 30 8.19 30C12.72 30 16.38 26.34 16.38 21.81V8.19C16.38 3.66 12.72 0 8.19 0ZM15.27 21.81C15.27 25.74 12.09 28.92 8.19 28.92C4.29 28.92 1.11 25.74 1.11 21.81V8.19C1.11 4.26 4.29 1.08 8.19 1.08C12.09 1.08 15.27 4.26 15.27 8.19V21.81ZM12.3 22.98L8.43 26.88C8.28 27 8.1 27 7.95 26.88L4.08 22.98C3.93 22.86 3.93 22.65 4.08 22.53L4.86 21.75C4.98 21.63 5.19 21.63 5.31 21.75L7.98 24.42C8.1 24.54 8.31 24.54 8.43 24.42L11.1 21.75C11.22 21.63 11.43 21.63 11.55 21.75L12.33 22.53C12.45 22.65 12.45 22.86 12.3 22.98Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollFurther);
export default __webpack_public_path__ + "static/media/scroll-further.bb54d847dbf7fe35155c8c69db8f3601.svg";
export { ForwardRef as ReactComponent };